import { resolveCommonValue } from '@/modules/outputs/utils';
import type { TResolvedValue } from '@/modules/outputs/types';
import type { IFunctionCallEvent } from '../hooks/useRunJournalEvents';

/** An external call paired with its resolved output value. */
export interface IResolvedExternalCall {
  call: IFunctionCallEvent;
  /** Resolved once by the caller so the reference stays stable across renders. */
  output: TResolvedValue | null;
}

/**
 * Resolves each of a step's external calls to its output value.
 *
 * Every call is kept, in execution order: surfaces show one row per call with
 * its output under it, rather than folding the plainer ones away.
 *
 * @param calls - The step's external calls, in execution order
 * @returns Each call with its resolved output, or null when it returned nothing
 */
export function resolveExternalCalls(
  calls: IFunctionCallEvent[] | undefined,
): IResolvedExternalCall[] {
  return (calls ?? []).map(call => ({
    call,
    output:
      call.returnValue != null ? resolveCommonValue(call.returnValue) : null,
  }));
}
